import { createContext } from "react";
export const gameStatsContext = createContext({});
